import * as Preact from "preact"

import App from "@fae/source/models/App.js"

let UnitSprite = function() {}
import("@fae/source/views/components/UnitSprite.jsx").then((module) => UnitSprite = module.default)
import UnitHealthBar from "@fae/source/views/components/UnitHealthBar.jsx"
import Dice from "@fae/source/data/games/ember/views/Dice.jsx"
import DiceLayout from "@fae/source/data/games/ember/views/DiceLayout.jsx"

import CarryOn from "@fae/source/data/games/ember/utility/CarryOn.js"
import * as PlotSteps from "@fae/source/data/plot/steps.js"

import "./InterstitialModal.less"

export default function InterstitialModal() {
    return [
        PlotSteps.CustomViewModal({
            "view": (stage) => {
                if(App?.game == undefined) return

                return (
                    <div class="InterstitialModal">
                        <section class="ManageSection">
                            Equipment
                        </section>
                        <section class="ContinueSection">
                            <div class="ContinueButton" onClick={(event) => CarryOn(stage)}>
                                Continue
                            </div>
                        </section>
                    </div>
                )
            }
        })
    ]
}
